import { Box, Divider, Text } from '@wix/design-system';
import { ArrowLeftSmall, ArrowRightSmall, Article } from '@wix/wix-ui-icons-common';
import React, { FC } from 'react';

import { categoryPageArticleListItemDataHooks } from './dataHooks';
import css from './styles.scss';

const TOOLTIP_ENTER_DELAY = 300;

// TODO: Move to centralized place in shared components library.
export enum Theme {
  Mobile = 'mobile',
  Desktop = 'desktop',
  Widget = 'widget',
}

type CategoryPageArticle = {
  id: string;
  title: string;
};

type Props = {
  categoryPageArticle: CategoryPageArticle;
  LinkComponent: React.ComponentType<any>;
  onArticleClick: () => void;
  linkProps?: Record<string, any>;
  isRTLLanguage?: boolean;
  theme: Theme;
};

const tooltipWidth = {
  [Theme.Mobile]: '720px',
  [Theme.Desktop]: '720px',
  [Theme.Widget]: '380px',
};

export const CategoryPageArticleListItem: FC<Props> = ({
  categoryPageArticle,
  LinkComponent,
  onArticleClick,
  linkProps = {},
  isRTLLanguage = false,
  theme,
}) => {
  const { id, title } = categoryPageArticle;

  return (
    <Box key={id} padding="0 SP3" direction="vertical">
      <Box padding="SP3 0" verticalAlign="middle">
        <LinkComponent
          className={css.articleLink}
          dataHook={categoryPageArticleListItemDataHooks.categoryArticleSectionLink()}
          onClick={onArticleClick}
          {...linkProps}
        >
          <Box align="space-between" verticalAlign="middle" columnGap={24} width="100%">
            <Box gap="1">
              <Article className={css.articleIcon} />
              <Text
                size="medium"
                maxLines={2}
                ellipsis
                showTooltip={true}
                tooltipProps={{
                  maxWidth: tooltipWidth[theme],
                  enterDelay: TOOLTIP_ENTER_DELAY,
                }}
                className={css.articleTitle}
              >
                {title}
              </Text>
            </Box>
            {isRTLLanguage ? <ArrowLeftSmall /> : <ArrowRightSmall />}
          </Box>
        </LinkComponent>
      </Box>
      <Divider />
    </Box>
  );
};
